import Util from "../../common/Util";
import BIModuleConfig from "./BIModuleConfig";

export default class BIModuleService {
	static getHomeStats(params) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = BIModuleConfig.endpoint + Util.buildQueryString(params);
				let response = await BIModuleConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static getChildrenStats(params) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					BIModuleConfig.endpointChildrenStats + Util.buildQueryString(params);
				let response = await BIModuleConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/BIModule/BIModuleService.js